import { useState } from 'react'
import { adminTrpcClient } from 'shared/api'
import { installBrowserAdminSession } from 'shared/lib/auth/session'
import { Button } from 'shared/components/ui/button'
import { Card, CardContent, CardHeader, CardTitle } from 'shared/components/ui/card'
import { Field, FieldLabel } from 'shared/components/ui/field'
import { Input } from 'shared/components/ui/input'
import { useTranslate } from 'shared/lib/i18n'

export function AdminLogin() {
	const { t } = useTranslate()
	const [username, setUsername] = useState('')
	const [password, setPassword] = useState('')
	const [error, setError] = useState<string | null>(null)
	const [pending, setPending] = useState(false)

	async function handleSubmit(e: React.FormEvent) {
		e.preventDefault()
		setError(null)
		setPending(true)
		try {
			const session = await adminTrpcClient.auth.Login.mutate({ username, password })
			installBrowserAdminSession(session)
		} catch {
			setError(t('pages.adminLogin.invalidCredentials'))
		} finally {
			setPending(false)
		}
	}

	return (
		<div className="flex min-h-svh items-center justify-center p-4">
			<Card className="w-full max-w-sm">
				<CardHeader>
					<CardTitle>{t('pages.adminLogin.title')}</CardTitle>
				</CardHeader>
				<CardContent>
					<form className="space-y-4" onSubmit={handleSubmit}>
						<Field>
							<FieldLabel htmlFor="username">{t('pages.adminLogin.username')}</FieldLabel>
							<Input id="username" autoComplete="username" value={username} onChange={(e) => setUsername(e.target.value)} />
						</Field>
						<Field>
							<FieldLabel htmlFor="password">{t('pages.adminLogin.password')}</FieldLabel>
							<Input id="password" type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} />
						</Field>
						{error && <p className="text-sm text-destructive">{error}</p>}
						<Button type="submit" disabled={pending || !username || !password} className="w-full">
							{pending ? t('pages.adminLogin.signingIn') : t('pages.adminLogin.signIn')}
						</Button>
					</form>
				</CardContent>
			</Card>
		</div>
	)
}
